<template>
  <div>
    <my-header></my-header>

    <div class="section-container">
      <side-nav
        :menuItems="menuItems"
        class="side-nav"
      />

      <div class="content-box">
        <h2>Season {{seasonId}}</h2>
        <router-view></router-view>
      </div>
    </div>

  </div>
</template>

<script>
import MyHeader from './Header.vue';
import SideNav from './SideNav.vue';

export default {
  name: 'Season',

  components: {
    MyHeader,
    SideNav,
  },

  props: {
    seasonId: {
      type: Number,
      required: true,
    },
  },

  computed: {
    menuItems() {
      return [
        {
          title: 'Info',
          route: {name: 'season_info', params: {seasonId: this.seasonId}},
        },
      ];
    },
  },
}
</script>

<style scoped>
.section-container {
  display: flex;
}

.side-nav {
  margin-right: 3em;
}

.content-box {
  width: 600px;
  padding-top: 1em;
}
</style>
